export const REGISTER = "auth/register"
export const LOGIN = "auth/login"
export const UPDATE = "/auth/updateUser"
export const JOBS = "/jobs"
export const STATS = "/jobs/stats"
// export const GET_JOBS = "https://jsearch.p.rapidapi.com/search"
// export const GET_JOBS = "https://serpapi.com/search.json"
export const GET_JOBS = "https://api.adzuna.com/v1/api/jobs"